import React from "react"
import Layout from "../components/layout"
import Head from "../components/head"
import commonStyles from "./common-styles.module.scss"
import { getLinkByPageKey, pageKeys } from "../utils/navHelper"
import {
  INDIVIDUAL_THERAPY_NAME,
  RELATIONSHIPS_THERAPY_NAME,
  PATERNITY_FATHERHOOD_COACHING_NAME
} from "../data/whatIOfferData"

const IndexPage = () => {
  return (
    <Layout isHome={true}>
      <Head
        title="Home"
        description="Online coaching, CBT and IFS therapy for individuals and couples. Supporting you towards greater awareness, vitality, and alignment with your values."
      />
      <h2>Welcome</h2>

      <div className={commonStyles.introRow}>
        <div className={commonStyles.introText}>
          <p>
            I am a psychotherapist and coach working with individuals, couples,
            and groups. My role is to help you connect with how you want to be
            in the world and support you in putting that into practice. It's a
            journey that naturally includes insight, obstacles, and change.
          </p>
          <div className={commonStyles.offerButtonRow}>
            {getLinkByPageKey(
              pageKeys.WHAT_I_OFFER,
              false,
              INDIVIDUAL_THERAPY_NAME,
              {
                openSectionIndex: 0
              }
            )}
            {getLinkByPageKey(
              pageKeys.WHAT_I_OFFER,
              false,
              RELATIONSHIPS_THERAPY_NAME,
              {
                openSectionIndex: 1
              }
            )}
            {getLinkByPageKey(
              pageKeys.WHAT_I_OFFER,
              false,
              PATERNITY_FATHERHOOD_COACHING_NAME,
              { openSectionIndex: 2 }
            )}
          </div>

          <p>
            My work draws on a variety of therapeutic approaches and
            philosophies, including Internal Family Systems (IFS), Cognitive
            Behavioural Therapy (CBT), Gestalt, Feminism, and Non-Violent
            Communication (NVC), and I adapt how I work to each person and
            relationship.
          </p>
        </div>

        <div className={commonStyles.introImageContainer}>
          <img
            className={commonStyles.introImage}
            src="/gavin_lashley_headshot.jpeg"
            alt="Gavin Lashley headshot"
          />
        </div>
      </div>
      <blockquote className={commonStyles.quoteBlock}>
        <p>
          <q>
            <cite>
              You don't have to control your thoughts. You just have to stop
              letting them control you.
            </cite>
          </q>{" "}
          <span className={commonStyles.quoteAuthor}>Dan Millman</span>
        </p>
      </blockquote>
      <p>
        Taking the step to look for a therapist or coach can be a daunting one,
        so I invite you to use the resources on this site to help address any
        fears, queries, or doubts you may have. You'll find more detailed
        information about how I work in the{" "}
        {getLinkByPageKey(
          pageKeys.WHAT_I_OFFER,
          false,
          "different formats I offer"
        )}
        , and some of your questions may be answered on the{" "}
        {getLinkByPageKey(pageKeys.FAQ, true)}.
      </p>
      <p>
        On the {getLinkByPageKey(pageKeys.ABOUT_ME)} page I include a short
        introductory video to bring my voice and personality to life and give
        you a better feel for who I am.
      </p>
      <p>
        If you have questions or would like to talk about how we might work
        together, visit the {getLinkByPageKey(pageKeys.BOOK_A_SESSION)} page.
      </p>
    </Layout>
  )
}

export default IndexPage
